import React, { useState } from 'react';
// import images
import logo from "../../assets/images/logo.svg";
import { Link } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { toast } from 'react-toastify';
import LoaderModal from '../ModalLoader/LoaderModal';
const ForgotPassword = () => {

// for loading modal ==>
  const [showModal, setShowModal] = useState(false);



  const APi_Url=process.env.REACT_APP_ENIGMA_API;

  const initialValues = {
    userName: '',
    
  };

  const validationSchema = Yup.object({
    userName: Yup.string().email("Invalid email format")
    .required("Email is Required")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Email domain must be a valid domain"
    ),
    
  });



  const onSubmit = async (values, { setSubmitting }) => {
    setShowModal(true);
    
    const email=values.userName.toLowerCase();
    const Scheme='https';
    const Host='enigma.smarttradingblueprint.com';
    
    try {
      const response = await axios.post(
        `${APi_Url}api/auth/send-mail-forgot-password/${email}/${Scheme}/${Host}`,{},

        {
          headers: {
            'Accept': "*",
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "secure": false,
   "changeOrigin": true
          }
        }
      );
      setShowModal(false);
      // console.log('Response:', response.data.response);
      toast.success(response.data.response);
      
      // Handle response data as needed
    } catch (error) {
      setShowModal(false);
      // console.error('Error ', error.response.data.response);
      toast.error(error.response.data.response);
    } finally {
      setSubmitting(false); // Make sure to reset form state, if applicable
    }
  };
  

  return (
    <>
    <div className="sign_in_wrp">
    <div className="sign_in_wrp_cntnr">
      <div className="sign_in_innr">
        <div className="sign_in_innr_wrp">
          <div className="img_prt">
              <img src={logo} alt="logo_icon"/>
              <h2> Welcome </h2>
              {/* <h2>Dashboard</h2> */}
          </div>
          <div className="cnct_prt">
            <div className="sign_in_cnct">
              <div className="sgn_pg_lgo">
                {/* <a href="#">
                  <img src={logo} alt="logo_icon"/>
                </a> */}
              </div>          
              <div className="frm_wrp">
                <h6>Forgot Password</h6>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                  >
                    {({ isSubmitting }) => (
                <Form >
                  <div className="frm_fld">
                    <label>email</label>
                    <Field type="email" id="userName" name="userName" placeholder="userName" className="input"/>
                    <ErrorMessage name="userName" component="div" className="error_msg" />
                  </div>
                 
                 
                  <div className="frm_fld">
                    <input type="submit" disabled={isSubmitting} value="Forgot Password" />
                  </div>
                  <div className="frm_fld crt_btn_fld">
                    <Link to={'/'} className="crt_btn">Sign in</Link>
                  </div>
                </Form>)}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
   <LoaderModal show={showModal} />
</>
  )
}

export default ForgotPassword
